import { Auth } from '@nackle/bridge';
import { idUrl } from 'endpoints';
import { applyRequestMiddleware } from './fetch';

const auth = new Auth( {
    authority: idUrl,
    automaticSilentRenew: false
} );

export default auth;

applyRequestMiddleware( function( url, options ) {
    options.headers = {
        ...( options.headers || {} )
    };

    if ( auth.state.accessToken ) {
        options.headers.authorization = `Bearer ${ auth.state.accessToken } `;
    }
} );

